<template>
  <div class="worked-example border border-[var(--mt-border)] rounded-lg overflow-hidden mb-4">
    <!-- Header (clickable to expand/collapse) -->
    <button
      class="w-full p-4 flex items-center justify-between bg-[var(--mt-bg-subtle)] hover:bg-[var(--mt-hover)] transition text-left"
      @click="expanded = !expanded"
    >
      <div class="flex items-center gap-3">
        <div
          class="w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold"
          :style="{ background: 'var(--mt-accent-blue-muted)', color: 'var(--mt-accent-blue)' }"
        >
          {{ index + 1 }}
        </div>
        <span class="font-medium">{{ example.problem }}</span>
      </div>

      <MTIcon
        :name="expanded ? 'chevron-up' : 'chevron-down'"
        :size="20"
        class="text-[var(--mt-text-muted)]"
      />
    </button>

    <!-- Expandable content -->
    <transition name="expand">
      <div v-if="expanded" class="p-4 border-t border-[var(--mt-border)]">
        <!-- Steps -->
        <div v-if="example.steps?.length" class="mb-4">
          <h4 class="text-sm font-semibold text-[var(--mt-text-muted)] mb-2">Steps:</h4>
          <ol class="list-decimal list-inside space-y-1 text-sm">
            <li v-for="(step, idx) in example.steps" :key="idx">
              {{ step }}
            </li>
          </ol>
        </div>

        <!-- Answer -->
        <div class="mb-4">
          <h4 class="text-sm font-semibold text-[var(--mt-text-muted)] mb-1">Answer:</h4>
          <div class="text-lg font-bold text-green-500">
            {{ example.answer }}
          </div>
        </div>

        <!-- Explanation -->
        <div v-if="example.explanation" class="rounded-lg p-3" :style="{ background: 'var(--mt-accent-blue-muted)' }">
          <div class="flex items-start gap-2">
            <MTIcon name="lightbulb" :size="16" :style="{ color: 'var(--mt-accent-blue)' }" class="mt-0.5 flex-shrink-0" />
            <p class="text-sm" :style="{ color: 'var(--mt-accent-blue)' }">{{ example.explanation }}</p>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref } from "vue";
import MTIcon from "@/components/ui/MTIcon.vue";

defineProps({
  example: {
    type: Object,
    required: true
  },
  index: {
    type: Number,
    default: 0
  }
});

const expanded = ref(false);
</script>

<style scoped>
.expand-enter-active,
.expand-leave-active {
  transition: all 0.2s ease;
  overflow: hidden;
}

.expand-enter-from,
.expand-leave-to {
  opacity: 0;
  max-height: 0;
}

.expand-enter-to,
.expand-leave-from {
  opacity: 1;
  max-height: 500px;
}
</style>
